export enum FeedbackTrigger {
  ELECTIVE = 'ELECTIVE',
  SESSIONS_5 = 'SESSIONS_5',
  SESSIONS_20 = 'SESSIONS_20',
  SESSIONS_50 = 'SESSIONS_50',
}
